<template>
	<div class="home_page">
		<english v-if="!loading"></english>
		<div class="flex2 load_page" v-show="loading">
			<img src="@/images/load.gif" />
		</div>
		<div class="kp_box" v-show="kaiPing==2&&!isPhone&&!loading">
			<img class="kp_left animate__animated animate__slideOutLeft" src="@/images/open1.png" />
			<img class="kp_right animate__animated animate__slideOutRight" src="@/images/open2.png" />
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import english from './english/index';
export default {
	components: {
		english,
	},
	data() {
		return {
			isPhone: this.$isMobile,
            loading: true,
		};
	},
	computed: {
		...mapState(["kaiPing"]),
	},
	created() {
        this.loading = this.$store.state.loadPage;
		this.getLan();
	},
	methods: {
		// 获取中英文
		async getLan() {
			const res = await this.$api.nowClientIP();
			if (res.code == 1) {
				setTimeout(() => {
					this.$store.state.loadPage = false;
                    this.loading = false;
                    //1不显示 2显示 3已经显示过了
					if (this.$store.state.kaiPing == 1) {
						this.$store.state.kaiPing = 2;//默认开屏页不显示，数据加载好后开屏动画执行
					}
				}, 1500);
				setTimeout(() => {
					this.$store.state.kaiPing = 3;//2.5秒后开屏动画消失
				}, 4000);
			} else {
				setTimeout(() => {
					this.$store.state.loadPage = false;
                    this.loading = false;
				}, 4000);
			}
		},
	}
};
</script>
<style lang="scss">
.load_page{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999999999999999;
    background-color: #fff;
    width: 100vw;
    height: 100vh;
    img{
        width: 100px;
        height: 75px;
    }
}
.home_page {
	.kp_box {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		z-index: 5000;
		display: flex;
		img {
			width: 50%;
			display: inline-block;
		}
		.kp_left {
			animation-delay: 0.5s;
			animation-duration: 2.5s;
		}
		.kp_right {
			animation-delay: 0.5s;
			animation-duration: 2.5s;
		}
	}
}
</style>